import { PlanType } from "@/types/PlanTypes";
import { TProxyPlanKey } from "../hooks/useProxyPlanKey";
import getProxyPlanKey from "@/utils/getProxyPlanKey";

export type TProxyTabType =
  | "datacenter"
  | "staticResidential"
  | "residential"
  | "verified";

export default function makeProxyTabType(
  proxyPlan: TProxyPlanKey
): TProxyTabType {
  switch (proxyPlan) {
    case "shared_default":
    case "semidedicated_premium":
    case "dedicated_premium":
      return "datacenter";
    case "shared_isp":
    case "semidedicated_isp":
    case "dedicated_isp":
      return "staticResidential";
    case "shared_residential":
      return "residential";
    case "shared_verified":
      return "verified";
    default:
      return "datacenter";
  }
}

/**
 * Get one of 4 options based on the plan
 * @params {PlanType} Partial plan type
 * @returns datacenter | staticResidential | residential | verified
 */
export function makeTabTypeFromPlan(
  params:
    | Partial<
        Pick<
          PlanType,
          | "proxy_type"
          | "proxy_subtype"
          | "required_site_checks"
          | "proxy_count"
        >
      >
    | undefined
): TProxyTabType {
  const { proxy_type, proxy_subtype, required_site_checks, proxy_count } =
    params || {};
  return makeProxyTabType(
    getProxyPlanKey({
      proxy_type: proxy_type || "shared",
      proxy_subtype: proxy_subtype || "default",
      required_site_checks: required_site_checks,
      proxy_count: proxy_count || 0,
    })
  );
}
